import { call, select, takeLatest, put, take, takeEvery } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import * as actions from 'modules/campaigns/actions/core';
import * as types from 'modules/campaigns/actionTypes';
import { DASHBOARD_SOURCE } from 'modules/campaigns/constants';
import { getBaseRequestParams } from 'modules/campaigns/selectors/dashboard';
import { getSelectedDealerId } from 'selectors/dealerSelectors';

import { afterCreateCampaign, createCampaignMatcher, duplicateCampaignMatcher } from './common';

const onFilterChange = ({ type }) =>
  [
    SELECT_DEALER,
    types.DELETE_CAMPAIGN_SUCCESS,
    types.SET_CAMPAIGNS_DASHBOARD_FILTER,
    types.SET_CAMPAIGNS_DASHBOARD_FILTERS,
    types.CLEAR_CAMPAIGNS_DASHBOARD_FILTER,
    types.REMOVE_CAMPAIGNS_DASHBOARD_FILTER,
  ].includes(type);

function* refreshDashboard() {
  const params = yield select(getBaseRequestParams);
  yield put(actions.fetchCampaigns({ ...params, page: 0 }, { source: DASHBOARD_SOURCE }));
}

function* onDashboardWorker() {
  const dealerId = yield select(getSelectedDealerId);
  if (!dealerId) {
    yield take(SELECT_DEALER);
  }

  yield call(refreshDashboard);
  yield takeLatest(onFilterChange, refreshDashboard);
  yield takeEvery(createCampaignMatcher, afterCreateCampaign);
  yield takeEvery(duplicateCampaignMatcher, afterCreateCampaign);
}

export default function* campaignsDashboardSaga() {
  yield scopeToPage([PATH.CAMPAIGNS_DASHBOARD], onDashboardWorker);
}
